
    import { css } from 'lit-element';
    export default css`:host([name^=flag-]){--flag-outline:var(--kat-icon-flag-outline,1px solid #d5dbdb)}:host([name^=flag-]) img{outline:var(--flag-outline)}`;
  